import { render, staticRenderFns } from "./unit_module_activity_view.vue?vue&type=template&id=98c4eb90&"
import script from "./unit_module_activity_view.vue?vue&type=script&lang=js&"
export * from "./unit_module_activity_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports